import React, { ReactElement, useMemo, useState } from "react";
import { StatsService } from "../../stats";
import { Loading } from "../../ui";
import { UserStatsTableRow } from "./UserStatsTableRow";

export const UserStatsTable = (props: any): ReactElement => {
	const [stats, setStats] = useState<any>();
	const statsService = new StatsService();

	const fetchUserStats = async () => {
		const userStats = await statsService.findUserStats(props.date);
		setStats(userStats);
	};

	useMemo(() => {
		fetchUserStats();
	}, [props.date]);

	if (!stats) {
		return (
			<div className="loading-stats">
				<Loading /> Loading stats...
			</div>
		);
	}

	if (stats.length === 0) {
		return (
			<div className="empty-stats">
				<i className="fa fa-inbox"></i>
				<span>No performance data available</span>
			</div>
		);
	}

	// Sort by sales this month (highest first)
	const sortedStats = [...stats].sort((a: any, b: any) => 
		(Number(b.sales_this_month) || 0) - (Number(a.sales_this_month) || 0)
	);

	return (
		<div className="user-stats-grid">
			{sortedStats.map((stat: any, index: number) => (
				<UserStatsTableRow 
					key={stat.id || stat.name || index} 
					stats={stat} 
					isTopPerformer={index === 0}
					rank={index + 1}
				/>
			))}
		</div>
	);
};
